import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { MESSAGE_KEYWORD } from '../_utils/reserved-keywords';
import { useHandleApp } from './useHandleApp';
export const useAdvertisingId = () => {
  const $ = _c(9);
  const osType = useDeviceInfoStore(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      type: MESSAGE_KEYWORD.GET_ADVERTISING_ID
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    request,
    response,
    isPending
  } = useHandleApp(t0);
  let t1;
  let t2;
  if ($[1] !== osType || $[2] !== request) {
    t1 = () => {
      if (!osType) {
        return;
      }
      request();
    };
    t2 = [request, osType];
    $[1] = osType;
    $[2] = request;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  const advertisingId = response?.isSuccess && response.data ? response.data.advertisingId : null;
  const platform = response?.isSuccess && response.data ? response.data.platform : null;
  let t3;
  if ($[5] !== advertisingId || $[6] !== isPending || $[7] !== platform) {
    t3 = {
      advertisingId,
      platform,
      isPending
    };
    $[5] = advertisingId;
    $[6] = isPending;
    $[7] = platform;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
function _temp(state) {
  return state.osType;
}